import * as React from 'react'
import { Viewer as ViewerComponent } from 'viper-viewer/dist/implementations/mapbox/web'
import { ViperViewProps } from 'viper-viewer/dist/types'

import config, { SERVER_PREFIXES } from '../../../config'

const Viewer = ({ planUrl, ...rest }: ViperViewProps) => {
  const url =
    window && window.location && window.location.origin
      ? planUrl.replace(config.ENV === 'dev' ? SERVER_PREFIXES.re7 : window.location.origin, '')
      : planUrl

  return <ViewerComponent {...rest} planUrl={url} />
}

export { Viewer }
